import axios from 'axios'
import Progress from 'react-progress-2'
import { getUserToken } from './user'
import { checkTokenExpiredTime } from './user-action'

const requestConfig = {
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 30000,
  validateStatus: status => status < 400,
}
const DEFAULT_HEADER = {
  common: {
    'Content-Type': 'application/json',
  },
}
const MULTIPART_HEADER = {
  'Content-Type':
    'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
}

const instance = axios.create(requestConfig)

async function getAddonHeaders({ isPrivate, isMultipart }) {
  let headers = {}
  if (isPrivate) {
    const jwtToken = getUserToken()
    checkTokenExpiredTime(jwtToken)
    headers.Authorization = `Bearer ${jwtToken}`
  }
  if (isMultipart) {
    headers = {
      ...headers,
      ...MULTIPART_HEADER,
    }
  }
  return headers
}

export default async function sendRequest({
  url,
  method,
  data,
  params,
  isPrivate = true,
  isMultipart = false,
}) {
  const addonHeaders = await getAddonHeaders({ isPrivate, isMultipart })
  const headers = {
    ...DEFAULT_HEADER,
    ...addonHeaders,
  }
  Progress.show()
  const result = await instance.request({
    url,
    method,
    data,
    params,
    headers,
  })
  Progress.hide()
  return result
}
